export const COMPLIANCE_BRAIN_URL =
  process.env.NODE_ENV === 'production' ? 'https://agent.cjtglobal.com' : 'http://agent.cjton-dev.business.xy';

export function getComplianceBrainUrl() {
  if (typeof window === 'undefined') return COMPLIANCE_BRAIN_URL;

  const token = localStorage.getItem('token');
  const sessionId = localStorage.getItem('sessionId');

  const url = new URL(COMPLIANCE_BRAIN_URL);
  url.searchParams.set('from', window.location.href);
  if (sessionId && token) {
    url.searchParams.set('s', sessionId);
    url.searchParams.set('t', token);
  }
  return url.toString();
}



// WEBPACK FOOTER //
// ./src/utils/complianceBrain.js